(function () {
  const outingEventsTeamsApp = function () {
    const bindDragNDrop = () => {
      const dropTeamsContainer = dragula(
        $(".players-needing-team, .team-container").toArray(),
        {}
      ).on("drop", setPlayerTeam);

      window.outingEventsTeamsApp = { dropTeamsContainer };
    };

    const setPlayerTeam = function (el, target) {
      var teamValue = $(target).hasClass("team-container") ? $(target).data("team-id") : "";
      $(el).find(".player-input").val(teamValue);
      updateSorts();
    };

    const submitForm = () => {
      $(".generic-loader").removeClass("d-none");
      $(".teams-form [data-disable-with]").trigger("click");
    };

    var updateSorts = function () {
      $(".team").each(function () {
        $(this)
          .find(".player")
          .each(function (i) {
            $(this).find(".player-sort-input").val(i);
          });
      });
    };

    const movePlayers = () => {
      $(".players-needing-team .player")
        .each(function () {
          const playerItem = this;
          const teamContainer = $(".team-container").filter(function () {
            return !$(this).html() || $(this).html().trim().length === 0;
          })[0];

          const html = $(playerItem).parent().parent()[0].outerHTML;
          $(teamContainer)[0].innerHTML = html;
          $(playerItem).parent().parent().remove();
          $(teamContainer).find(".player-input").val($(teamContainer).data("team-id"));
          updateSorts();
        })
        .promise()
        .done(submitForm);
    };

    const createOnePlayerTeams = function () {
      const size = $(".players-needing-team .player").length;
      const firstNumber = $(".team").length + 1;
      $.get({
        url: `/outings/events/${gon.event.id}/teams/new?size=${size}&number=${firstNumber}`,
      }).then(movePlayers);
    };

    $(document).on("turbolinks:load", () => {
      if (!$("body").hasClass("controller-outings-players")) return;

      bindDragNDrop();
      updateSorts();
      $("#create-one-player-teams").on("click", function (e) {
        window.stopEvent(e);

        window.swalConfirm.fire().then((result) => {
          if (!result.isConfirmed) return;

          createOnePlayerTeams();
        });
      });
    });
  };

  if (typeof window !== "undefined") {
    window.outingEventsTeamsApp = outingEventsTeamsApp();
  }
})();
